export const firebaseActionLink = {
    mode: 'mode',
    actionCode: 'oobCode',
    verifyEmailModeName: 'verifyEmail',
    resetPasswordModeName: 'resetPassword',
    getCurrentMode: () => {
        return getParameterByName('mode');
    },
    getCurrentActionCode: () => {
        return getParameterByName('oobCode');
    },
};

export function getParameterByName(name: string) {
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export const formatUrl = (url?: string | string[]) => {
    if (url?.includes('http')) return url;
    return 'https://' + url;
};

export function getSearchParam(key: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
}

export function deleteSearchParam(key: string) {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);
}
